import HttpRequest from './http_request'

export default class RoomTimetableProvider extends HttpRequest {
  async getTimetable({ year, semester, building_no, room_no }) {
    const { data } = await this.get('/', { function: 'get-room-timetable', year, semester, building_no, room_no })
    return data
  }
}
